export default {"src":"/_next/static/media/copy-own.9f61fc07.svg","height":32,"width":31};